import { FormikErrors, FormikTouched } from "formik";

function ErrorMessage({
  message,
  touched = false,
}: {
  message?:
    | string
    | FormikErrors<any>
    | string[]
    | FormikErrors<any>[]
    | undefined;
  touched?: boolean | FormikTouched<any> | FormikTouched<any>[] | undefined;
}) {
  const renderMessage = () => {
    if (!touched || !message) return null;
    if (typeof message === "string") {
      return message;
    }
    if (Array.isArray(message)) {
      return message.join(", "); // Join array of error messages into a string
    }
    return null;
  };

  return (
    <>
      <div className="error-message-text">{renderMessage()}</div>
    </>
  );
}
export default ErrorMessage;
